/**
 * This file was automatically generated by ontology-generator.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSON files in
 * tools/ontology-generator/src/nodespec/ and re-run the generator.
 */
import type { NodeLabel } from '../../types/schema'
import type { RelationshipType } from './relationships'

export interface GraphNodeTypeSchema {
  label: NodeLabel
  displayLabelField: string
  searchableProperties: string[]
  listColumns: string[]
  icon: string
  domainGroup: string
  allowedRelationships: RelationshipType[]
}

export const GRAPH_NODE_TYPE_REGISTRY: Readonly<Record<NodeLabel, GraphNodeTypeSchema>> = {
  EquipmentProperty: {
    label: 'EquipmentProperty',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'kind', 'unit'],
    listColumns: ['name', 'kind', 'unit'],
    icon: 'Box',
    domainGroup: 'Asset',
    allowedRelationships: ['MEASURED_BY']
  },
  Observable: {
    label: 'Observable',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'unit'],
    listColumns: ['name', 'unit'],
    icon: 'Box',
    domainGroup: 'Asset',
    allowedRelationships: ['MEASURED_BY', 'TRACKS_GOAL']
  },
  Setpoint: {
    label: 'Setpoint',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'unit'],
    listColumns: ['name', 'unit'],
    icon: 'Box',
    domainGroup: 'Asset',
    allowedRelationships: ['SET_BY']
  },
  Part: {
    label: 'Part',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'part_type', 'vendor', 'customer_pn', 'manufacturer_pn'],
    listColumns: ['name', 'part_type', 'customer_pn', 'manufacturer_pn'],
    icon: 'Box',
    domainGroup: 'Asset',
    allowedRelationships: [
      'HAS_PART',
      'HAS_OBSERVABLE',
      'HAS_SETPOINT',
      'EXHIBITS_SYMPTOM',
      'LOCATED_IN',
      'SUPPLIED_BY',
      'MANUFACTURED_BY'
    ]
  },
  Customer: {
    label: 'Customer',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'customer_code', 'region'],
    listColumns: ['name', 'customer_code', 'region'],
    icon: 'TrendingUp',
    domainGroup: 'Business',
    allowedRelationships: []
  },
  CustomerOrder: {
    label: 'CustomerOrder',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'customer_name', 'product_name'],
    listColumns: ['name', 'customer_name', 'product_name'],
    icon: 'TrendingUp',
    domainGroup: 'Business',
    allowedRelationships: ['FOR_PRODUCT', 'FULFILLED_BY']
  },
  DemandForecast: {
    label: 'DemandForecast',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'product_name', 'period'],
    listColumns: ['name', 'product_name', 'period'],
    icon: 'TrendingUp',
    domainGroup: 'Business',
    allowedRelationships: ['FOR_PRODUCT']
  },
  DemandHistory: {
    label: 'DemandHistory',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'product_name', 'period'],
    listColumns: ['name', 'product_name', 'period'],
    icon: 'TrendingUp',
    domainGroup: 'Business',
    allowedRelationships: ['FOR_PRODUCT']
  },
  Compute: {
    label: 'Compute',
    displayLabelField: 'name',
    searchableProperties: [
      'id',
      'name',
      'host',
      'url',
      'compute_type',
      'vendor',
      'version',
      'opc_endpoint',
      'opc_root_node_id',
      'kind'
    ],
    listColumns: ['name', 'compute_type', 'host', 'vendor'],
    icon: 'Cpu',
    domainGroup: 'Compute',
    allowedRelationships: [
      'NETWORKS_WITH',
      'HAS_TAG_PROVIDER',
      'HAS_DATABASE',
      'BELONGS_TO',
      'MAPS_TO_CONTROLLER',
      'HOSTS'
    ]
  },
  TagProvider: {
    label: 'TagProvider',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'protocol'],
    listColumns: ['name', 'protocol'],
    icon: 'Cpu',
    domainGroup: 'Compute',
    allowedRelationships: ['PROVIDES']
  },
  Tag: {
    label: 'Tag',
    displayLabelField: 'name',
    searchableProperties: [
      'id',
      'name',
      'tag_path',
      'tag_system',
      'ignition_tag_type',
      'data_type',
      'folder',
      'opc_item_path',
      'opc_server',
      'plc_tag_path',
      'opc_node_id',
      'mtc_type',
      'mtc_uuid',
      'mtc_data_item_name',
      'pi_web_id',
      'pi_point_name',
      'pi_dataserver_web_id',
      'pi_dataserver_name',
      'aveva_tag_name',
      'aveva_attribute_name'
    ],
    listColumns: ['name', 'tag_path', 'tag_system', 'ignition_tag_type'],
    icon: 'Tag',
    domainGroup: 'Compute',
    allowedRelationships: [
      'CALCULATED_BY',
      'DERIVES_FROM',
      'USES_DATABASE',
      'MAPS_TO_CONTROL_TAG',
      'HAS_ALARM'
    ]
  },
  Alarm: {
    label: 'Alarm',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'priority', 'mode', 'tag_path', 'display_path'],
    listColumns: ['name', 'priority', 'mode', 'tag_path'],
    icon: 'BellRing',
    domainGroup: 'Compute',
    allowedRelationships: []
  },
  Database: {
    label: 'Database',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'database_type', 'url'],
    listColumns: ['name', 'database_type', 'url'],
    icon: 'Database',
    domainGroup: 'Compute',
    allowedRelationships: ['HAS_PSS_TAG', 'HAS_EVENT_JOURNAL', 'CONTAINS_TABLE']
  },
  Folder: {
    label: 'Folder',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'path', 'provider_name'],
    listColumns: ['name', 'path', 'provider_name'],
    icon: 'Cpu',
    domainGroup: 'Compute',
    allowedRelationships: ['CONTAINS']
  },
  Table: {
    label: 'Table',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'schema'],
    listColumns: ['name', 'schema'],
    icon: 'Database',
    domainGroup: 'Compute',
    allowedRelationships: ['STORES']
  },
  NamedQuery: {
    label: 'NamedQuery',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'path', 'query_type', 'database'],
    listColumns: ['name', 'path', 'query_type', 'database'],
    icon: 'FileCode2',
    domainGroup: 'Database',
    allowedRelationships: ['USES_DATABASE', 'USES_TABLE']
  },
  QueryTag: {
    label: 'QueryTag',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'datasource'],
    listColumns: ['name', 'datasource'],
    icon: 'Database',
    domainGroup: 'Database',
    allowedRelationships: ['USES_DATABASE']
  },
  DcsController: {
    label: 'DcsController',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'vendor', 'model', 'ip_address', 'source_guid'],
    listColumns: ['name', 'vendor', 'model', 'ip_address'],
    icon: 'Gauge',
    domainGroup: 'DCS',
    allowedRelationships: ['INSTANTIATES', 'CONTAINS', 'HOSTS', 'PARTNER_OF']
  },
  Cee: {
    label: 'Cee',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'ip_address', 'source_guid'],
    listColumns: ['name', 'ip_address', 'source_guid'],
    icon: 'Gauge',
    domainGroup: 'DCS',
    allowedRelationships: ['INSTANTIATES', 'CONTAINS']
  },
  ControlModule: {
    label: 'ControlModule',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'module_type', 'source_guid'],
    listColumns: ['name', 'module_type'],
    icon: 'Gauge',
    domainGroup: 'DCS',
    allowedRelationships: ['INSTANTIATES', 'CONTAINS', 'ASSIGNED_TO', 'EXPOSES']
  },
  FunctionBlock: {
    label: 'FunctionBlock',
    displayLabelField: 'name',
    searchableProperties: [
      'id',
      'name',
      'block_type',
      'template_name',
      'block_role',
      'kind',
      'source_guid'
    ],
    listColumns: ['name', 'block_type', 'block_role'],
    icon: 'Gauge',
    domainGroup: 'DCS',
    allowedRelationships: ['INSTANTIATES', 'CONTAINS', 'WIRED_TO', 'SIGNAL_FLOWS_TO']
  },
  BlockType: {
    label: 'BlockType',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'class_name', 'comp_type'],
    listColumns: ['name', 'class_name', 'comp_type'],
    icon: 'Gauge',
    domainGroup: 'DCS',
    allowedRelationships: ['DERIVED_FROM', 'HAS_PARAM_GROUP']
  },
  BlockParamGroup: {
    label: 'BlockParamGroup',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name'],
    listColumns: ['name'],
    icon: 'Gauge',
    domainGroup: 'DCS',
    allowedRelationships: []
  },
  BlockLibrary: {
    label: 'BlockLibrary',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'release'],
    listColumns: ['name', 'release'],
    icon: 'Gauge',
    domainGroup: 'DCS',
    allowedRelationships: ['PARENT_OF']
  },
  IoModule: {
    label: 'IoModule',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'card_type', 'iolink_name', 'source_guid'],
    listColumns: ['name', 'card_type'],
    icon: 'Gauge',
    domainGroup: 'DCS',
    allowedRelationships: ['INSTANTIATES', 'CONTAINS', 'ASSIGNED_TO', 'MOUNTED_ON']
  },
  IoChannel: {
    label: 'IoChannel',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'channel_type', 'source_guid'],
    listColumns: ['name', 'channel_type', 'channel_num'],
    icon: 'Gauge',
    domainGroup: 'DCS',
    allowedRelationships: ['INSTANTIATES', 'MOUNTED_ON']
  },
  ControlNamespace: {
    label: 'ControlNamespace',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name'],
    listColumns: ['name'],
    icon: 'Gauge',
    domainGroup: 'DCS',
    allowedRelationships: ['PROVIDES']
  },
  ControlTag: {
    label: 'ControlTag',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'param'],
    listColumns: ['name', 'param'],
    icon: 'Gauge',
    domainGroup: 'DCS',
    allowedRelationships: ['HAS_ALARM', 'WIRED_TO']
  },
  ControlAlarm: {
    label: 'ControlAlarm',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'alarm_type'],
    listColumns: ['name', 'alarm_type'],
    icon: 'Gauge',
    domainGroup: 'DCS',
    allowedRelationships: []
  },
  ControlSetpoint: {
    label: 'ControlSetpoint',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name'],
    listColumns: ['name'],
    icon: 'Gauge',
    domainGroup: 'DCS',
    allowedRelationships: ['SET_BY']
  },
  HumanLabor: {
    label: 'HumanLabor',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'description', 'operation_kind'],
    listColumns: ['name', 'operation_kind', 'description'],
    icon: 'Users',
    domainGroup: 'Human Labor',
    allowedRelationships: ['FEEDS', 'USES_EQUIPMENT', 'STAFFED_BY', 'SCHEDULED_BY', 'TRIGGERED_BY']
  },
  CrewRequirement: {
    label: 'CrewRequirement',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'description', 'headcount'],
    listColumns: ['name', 'headcount', 'description'],
    icon: 'UserRound',
    domainGroup: 'Human Labor',
    allowedRelationships: ['COVERS', 'STAFFED_BY']
  },
  Project: {
    label: 'Project',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'title', 'description', 'runtime_kind'],
    listColumns: ['name', 'title', 'description', 'runtime_kind'],
    icon: 'LayoutDashboard',
    domainGroup: 'Ignition Internal',
    allowedRelationships: ['HAS_EVENT_SCRIPT']
  },
  View: {
    label: 'View',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'path', 'view_type', 'title', 'runtime_kind'],
    listColumns: ['name', 'path', 'view_type', 'title'],
    icon: 'LayoutDashboard',
    domainGroup: 'Ignition Internal',
    allowedRelationships: ['BELONGS_TO', 'HAS_COMPONENT', 'VISUALIZES']
  },
  ViewComponent: {
    label: 'ViewComponent',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'component_type'],
    listColumns: ['name', 'component_type'],
    icon: 'LayoutDashboard',
    domainGroup: 'Ignition Internal',
    allowedRelationships: ['BINDS_TO', 'USES_QUERY']
  },
  UDTDefinition: {
    label: 'UDTDefinition',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'type_id'],
    listColumns: ['name', 'type_id'],
    icon: 'LayoutDashboard',
    domainGroup: 'Ignition Internal',
    allowedRelationships: ['HAS_MEMBER', 'INHERITS_FROM', 'HAS_ALARM_DEFINITION']
  },
  UDTMember: {
    label: 'UDTMember',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'member_type', 'data_type'],
    listColumns: ['name', 'member_type', 'data_type'],
    icon: 'LayoutDashboard',
    domainGroup: 'Ignition Internal',
    allowedRelationships: ['BELONGS_TO', 'HAS_MEMBER', 'INSTANCE_OF', 'USES_QUERY']
  },
  UDTParameter: {
    label: 'UDTParameter',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'data_type'],
    listColumns: ['name', 'data_type'],
    icon: 'LayoutDashboard',
    domainGroup: 'Ignition Internal',
    allowedRelationships: []
  },
  UDTInstance: {
    label: 'UDTInstance',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'udt_name'],
    listColumns: ['name', 'udt_name'],
    icon: 'LayoutDashboard',
    domainGroup: 'Ignition Internal',
    allowedRelationships: ['HAS_MEMBER', 'INSTANCE_OF']
  },
  Script: {
    label: 'Script',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'path', 'scope'],
    listColumns: ['name', 'path', 'scope'],
    icon: 'LayoutDashboard',
    domainGroup: 'Ignition Internal',
    allowedRelationships: ['CALLS_FUNCTION']
  },
  GatewayEvent: {
    label: 'GatewayEvent',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'project_name'],
    listColumns: ['name', 'project_name'],
    icon: 'LayoutDashboard',
    domainGroup: 'Ignition Internal',
    allowedRelationships: ['CALLS_FUNCTION']
  },
  GatewayEventHandler: {
    label: 'GatewayEventHandler',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'handler_type'],
    listColumns: ['name', 'handler_type'],
    icon: 'LayoutDashboard',
    domainGroup: 'Ignition Internal',
    allowedRelationships: ['CALLS_FUNCTION']
  },
  AuditProfile: {
    label: 'AuditProfile',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name'],
    listColumns: ['name'],
    icon: 'LayoutDashboard',
    domainGroup: 'Ignition Internal',
    allowedRelationships: ['BELONGS_TO']
  },
  ScheduleProfile: {
    label: 'ScheduleProfile',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'schedule_type'],
    listColumns: ['name', 'schedule_type'],
    icon: 'LayoutDashboard',
    domainGroup: 'Ignition Internal',
    allowedRelationships: ['BELONGS_TO', 'COMPOSES']
  },
  Holiday: {
    label: 'Holiday',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'date'],
    listColumns: ['name', 'date'],
    icon: 'LayoutDashboard',
    domainGroup: 'Ignition Internal',
    allowedRelationships: ['BELONGS_TO']
  },
  Product: {
    label: 'Product',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'product_code', 'category'],
    listColumns: ['name', 'product_code', 'category'],
    icon: 'Package',
    domainGroup: 'MES',
    allowedRelationships: []
  },
  Material: {
    label: 'Material',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'material_type', 'unit_of_measure'],
    listColumns: ['name', 'material_type', 'unit_of_measure'],
    icon: 'Package',
    domainGroup: 'MES',
    allowedRelationships: []
  },
  Recipe: {
    label: 'Recipe',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'product_name', 'version'],
    listColumns: ['name', 'product_name', 'version'],
    icon: 'Package',
    domainGroup: 'MES',
    allowedRelationships: ['USES_EQUIPMENT', 'FOR_PRODUCT', 'PRODUCES', 'CONSUMES']
  },
  Phase: {
    label: 'Phase',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'recipe_name'],
    listColumns: ['name', 'recipe_name'],
    icon: 'Package',
    domainGroup: 'MES',
    allowedRelationships: ['USES_EQUIPMENT', 'CONSUMES']
  },
  WorkOrder: {
    label: 'WorkOrder',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'product_name', 'status'],
    listColumns: ['name', 'product_name', 'status'],
    icon: 'Package',
    domainGroup: 'MES',
    allowedRelationships: ['FOR_PRODUCT', 'HAS_OPERATION']
  },
  ProductionGoal: {
    label: 'ProductionGoal',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'goal_id', 'scenario_id', 'window'],
    listColumns: ['name', 'goal_id', 'scenario_id', 'window'],
    icon: 'Package',
    domainGroup: 'MES',
    allowedRelationships: ['TARGET_VALUE_FROM', 'FOR_PRODUCT']
  },
  Batch: {
    label: 'Batch',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'work_order_name', 'status'],
    listColumns: ['name', 'work_order_name', 'status'],
    icon: 'Package',
    domainGroup: 'MES',
    allowedRelationships: ['RAN_ON', 'BATCH_OF', 'HAS_QUALITY_RESULT', 'CONSUMES']
  },
  Operation: {
    label: 'Operation',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'production_order_name', 'status'],
    listColumns: ['name', 'production_order_name', 'status'],
    icon: 'Package',
    domainGroup: 'MES',
    allowedRelationships: ['RAN_ON', 'EXECUTED_ON']
  },
  ProcessDeviation: {
    label: 'ProcessDeviation',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'batch_name', 'deviation_type', 'severity'],
    listColumns: ['name', 'batch_name', 'deviation_type', 'severity'],
    icon: 'Package',
    domainGroup: 'MES',
    allowedRelationships: ['AFFECTS_BATCH', 'OCCURRED_ON']
  },
  FunctionalLocation: {
    label: 'FunctionalLocation',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'location_type'],
    listColumns: ['name', 'location_type'],
    icon: 'Package',
    domainGroup: 'MES',
    allowedRelationships: ['PART_OF']
  },
  Vendor: {
    label: 'Vendor',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'vendor_code', 'vendor_kind'],
    listColumns: ['name', 'vendor_code', 'vendor_kind'],
    icon: 'Package',
    domainGroup: 'MES',
    allowedRelationships: []
  },
  QualityResult: {
    label: 'QualityResult',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'batch_name', 'parameter'],
    listColumns: ['name', 'batch_name', 'parameter'],
    icon: 'Package',
    domainGroup: 'MES',
    allowedRelationships: []
  },
  Asset: {
    label: 'Asset',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'full_item_name', 'kind', 'source_guid'],
    listColumns: ['name', 'full_item_name'],
    icon: 'Network',
    domainGroup: 'Network',
    allowedRelationships: ['CONTAINS', 'BELONGS_TO']
  },
  NetworkSegment: {
    label: 'NetworkSegment',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'segment_kind', 'kind', 'source_guid'],
    listColumns: ['name', 'segment_kind'],
    icon: 'Network',
    domainGroup: 'Network',
    allowedRelationships: ['CONTAINS', 'BELONGS_TO']
  },
  NetworkDevice: {
    label: 'NetworkDevice',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'device_kind', 'kind', 'ip_address', 'source_guid'],
    listColumns: ['name', 'device_kind', 'ip_address'],
    icon: 'Network',
    domainGroup: 'Network',
    allowedRelationships: ['CONTAINS', 'BELONGS_TO']
  },
  EmdbProject: {
    label: 'EmdbProject',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name'],
    listColumns: ['name', 'project_type'],
    icon: 'Network',
    domainGroup: 'Network',
    allowedRelationships: []
  },
  Organization: {
    label: 'Organization',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'code'],
    listColumns: ['name', 'code'],
    icon: 'Building2',
    domainGroup: 'Organization',
    allowedRelationships: ['HAS_SITE', 'HAS_PROCESS', 'HAS_SOAP_ENDPOINT']
  },
  Site: {
    label: 'Site',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name'],
    listColumns: ['name'],
    icon: 'Building2',
    domainGroup: 'Organization',
    allowedRelationships: [
      'HAS_COMPUTE',
      'HAS_SOAP_ENDPOINT',
      'HAS_LINE',
      'ACCOMPLISHES',
      'HAS_DATABASE',
      'CONTAINS',
      'HAS_UTILITY'
    ]
  },
  Controller: {
    label: 'Controller',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'type', 'vendor', 'project_name'],
    listColumns: ['name', 'type', 'vendor', 'project_name'],
    icon: 'CircuitBoard',
    domainGroup: 'PLC',
    allowedRelationships: ['HAS_TAG', 'COORDINATES', 'HAS_PATTERN']
  },
  Program: {
    label: 'Program',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'controller_name', 'type', 'folder', 'title'],
    listColumns: ['name', 'controller_name', 'type', 'folder'],
    icon: 'CircuitBoard',
    domainGroup: 'PLC',
    allowedRelationships: ['BELONGS_TO', 'HAS_TAG']
  },
  Routine: {
    label: 'Routine',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'program_name', 'type'],
    listColumns: ['name', 'program_name', 'type'],
    icon: 'CircuitBoard',
    domainGroup: 'PLC',
    allowedRelationships: ['BELONGS_TO', 'HAS_TAG', 'READS_TAG', 'WRITES_TAG']
  },
  AOI: {
    label: 'AOI',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'description'],
    listColumns: ['name', 'description'],
    icon: 'CircuitBoard',
    domainGroup: 'PLC',
    allowedRelationships: ['INSTANTIATES', 'BELONGS_TO', 'HAS_TAG']
  },
  PLCDataType: {
    label: 'PLCDataType',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'description'],
    listColumns: ['name', 'description'],
    icon: 'CircuitBoard',
    domainGroup: 'PLC',
    allowedRelationships: ['BELONGS_TO', 'HAS_MEMBER', 'MAPS_TO_TYPE']
  },
  PLCDataTypeMember: {
    label: 'PLCDataTypeMember',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'data_type', 'description'],
    listColumns: ['name', 'data_type', 'description'],
    icon: 'CircuitBoard',
    domainGroup: 'PLC',
    allowedRelationships: []
  },
  PLCTag: {
    label: 'PLCTag',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'data_type', 'device_class', 'description', 'aoi_name'],
    listColumns: ['name', 'data_type', 'device_class', 'description'],
    icon: 'CircuitBoard',
    domainGroup: 'PLC',
    allowedRelationships: [
      'CALCULATED_BY',
      'TRIGGERS',
      'GATES',
      'INHIBITS',
      'CONTROLS',
      'HAS_FLOW',
      'MAPS_TO_TAG',
      'OF_TYPE',
      'MAPS_TO_ROBOT_SIGNAL'
    ]
  },
  ControlPattern: {
    label: 'ControlPattern',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'pattern_type', 'description'],
    listColumns: ['name', 'pattern_type', 'description'],
    icon: 'CircuitBoard',
    domainGroup: 'PLC',
    allowedRelationships: ['CONTROLS']
  },
  DataFlow: {
    label: 'DataFlow',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'source_name', 'target_name', 'flow_type'],
    listColumns: ['name', 'source_name', 'target_name', 'flow_type'],
    icon: 'CircuitBoard',
    domainGroup: 'PLC',
    allowedRelationships: []
  },
  Procedure: {
    label: 'Procedure',
    displayLabelField: 'title',
    searchableProperties: ['id', 'title', 'procedure_kind', 'source_doc_id'],
    listColumns: ['title', 'procedure_kind', 'source_doc_id'],
    icon: 'ClipboardList',
    domainGroup: 'Procedure',
    allowedRelationships: [
      'PROCEDURE_FOR',
      'APPLIES_TO_PRODUCT',
      'REQUIRES_PART',
      'REQUIRES_SKILL_LEVEL'
    ]
  },
  Process: {
    label: 'Process',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'description', 'process_kind'],
    listColumns: ['name', 'description', 'process_kind'],
    icon: 'Workflow',
    domainGroup: 'Process',
    allowedRelationships: ['HAS_SUBPROCESS', 'LOCATED_IN']
  },
  Line: {
    label: 'Line',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'line_code', 'description'],
    listColumns: ['name', 'line_code', 'description'],
    icon: 'Workflow',
    domainGroup: 'Process',
    allowedRelationships: [
      'HAS_PRODUCTION_GOAL',
      'INSTANTIATES',
      'HAS_SUBLINE',
      'FEEDS',
      'HAS_EQUIPMENT',
      'HAS_OBSERVABLE',
      'MATERIALIZES',
      'HAS_UTILITY',
      'CONTROLLED_BY',
      'MONITORED_BY',
      'REQUIRES_LABOR',
      'HAS_LINE_OPERATION',
      'HAS_CREW_REQUIREMENT',
      'HAS_PROTECTIVE_FUNCTION'
    ]
  },
  LineOperation: {
    label: 'LineOperation',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'description', 'operation_kind', 'sequence_number'],
    listColumns: ['name', 'sequence_number', 'operation_kind', 'description'],
    icon: 'Workflow',
    domainGroup: 'Process',
    allowedRelationships: [
      'FEEDS',
      'USES_EQUIPMENT',
      'REQUIRES_LABOR',
      'RECOVERS',
      'FALLBACK_FOR',
      'SCHEDULED_BY',
      'TRIGGERED_BY'
    ]
  },
  Equipment: {
    label: 'Equipment',
    displayLabelField: 'name',
    searchableProperties: [
      'id',
      'name',
      'equipment_type',
      'hierarchical_name',
      'aveva_tag_name',
      'opc_node_id',
      'tag_number',
      'vendor'
    ],
    listColumns: ['name', 'equipment_type', 'tag_number', 'hierarchical_name'],
    icon: 'Factory',
    domainGroup: 'Process',
    allowedRelationships: [
      'FEEDS',
      'HAS_EQUIPMENT',
      'HAS_PART',
      'HAS_PROPERTY',
      'HAS_OBSERVABLE',
      'HAS_SETPOINT',
      'CONNECTS_TO',
      'MATERIALIZES',
      'MERGED_WITH',
      'MAPS_TO_TAG',
      'MAPS_TO_CONTROL_TAG',
      'EXHIBITS_SYMPTOM',
      'INDICATES',
      'LOCATED_IN',
      'REQUIRES_UTILITY',
      'CONTROLLED_BY',
      'MONITORED_BY',
      'HAS_ACTUATOR',
      'ASSOCIATED_WITH',
      'MAPS_TO_SAFETY_POINT'
    ]
  },
  PssTag: {
    label: 'PssTag',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'data_owner_name', 'description'],
    listColumns: ['name', 'data_owner_name', 'description', 'active'],
    icon: 'ScrollText',
    domainGroup: 'PSS',
    allowedRelationships: ['HAS_EVENT_JOURNAL']
  },
  PssEventJournal: {
    label: 'PssEventJournal',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'journal_kind', 'data_owner_name', 'table_name'],
    listColumns: ['name', 'journal_kind', 'data_owner_name', 'table_name'],
    icon: 'ScrollText',
    domainGroup: 'PSS',
    allowedRelationships: []
  },
  RobotController: {
    label: 'RobotController',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'vendor', 'model', 'controller_series', 'ip_address'],
    listColumns: ['name', 'vendor', 'model', 'ip_address'],
    icon: 'Bot',
    domainGroup: 'Robotics',
    allowedRelationships: ['CONTROLS', 'HOSTS', 'SUPERVISES', 'DEFINES']
  },
  RobotArm: {
    label: 'RobotArm',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'group', 'model'],
    listColumns: ['name', 'group', 'model'],
    icon: 'Bot',
    domainGroup: 'Robotics',
    allowedRelationships: ['HAS_JOB']
  },
  RobotJob: {
    label: 'RobotJob',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'job_type', 'group', 'language', 'vendor'],
    listColumns: ['name', 'job_type', 'group', 'language'],
    icon: 'Bot',
    domainGroup: 'Robotics',
    allowedRelationships: ['CALLS_JOB']
  },
  RobotIOSignal: {
    label: 'RobotIOSignal',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'address', 'direction', 'source_format'],
    listColumns: ['name', 'address', 'direction', 'source_format'],
    icon: 'Bot',
    domainGroup: 'Robotics',
    allowedRelationships: ['TRIGGERS', 'MAPS_TO_TAG', 'READ_BY', 'WRITTEN_BY']
  },
  RobotCondition: {
    label: 'RobotCondition',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'scheme', 'index', 'process_type', 'source_format'],
    listColumns: ['name', 'scheme', 'index', 'process_type'],
    icon: 'Bot',
    domainGroup: 'Robotics',
    allowedRelationships: ['USED_BY']
  },
  VisionProcess: {
    label: 'VisionProcess',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'vendor', 'vision_system', 'source_file'],
    listColumns: ['name', 'vision_system', 'applications', 'source_file'],
    icon: 'Bot',
    domainGroup: 'Robotics',
    allowedRelationships: ['USED_BY', 'OUTPUTS_TO', 'USES_VISION_DATA']
  },
  VisionData: {
    label: 'VisionData',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'vision_data_type', 'source_file'],
    listColumns: ['name', 'vision_data_type', 'source_file'],
    icon: 'Bot',
    domainGroup: 'Robotics',
    allowedRelationships: ['USED_BY']
  },
  Role: {
    label: 'Role',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'role_kind'],
    listColumns: ['name', 'role_kind'],
    icon: 'UserCog',
    domainGroup: 'Roles',
    allowedRelationships: []
  },
  ProtectiveFunction: {
    label: 'ProtectiveFunction',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'function_type', 'sil', 'description'],
    listColumns: ['name', 'function_type', 'sil', 'demand_mode'],
    icon: 'Shield',
    domainGroup: 'Safety',
    allowedRelationships: [
      'SENSED_BY',
      'ACTUATES',
      'PROTECTS',
      'SOLVED_BY',
      'IN_SECTION',
      'CITES',
      'FOR_SCENARIO',
      'IMPLEMENTED_BY'
    ]
  },
  LogicSolver: {
    label: 'LogicSolver',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'type', 'vendor'],
    listColumns: ['name', 'type', 'vendor'],
    icon: 'Cpu',
    domainGroup: 'Safety',
    allowedRelationships: ['CONTAINS', 'PART_OF']
  },
  SrsSection: {
    label: 'SrsSection',
    displayLabelField: 'name',
    searchableProperties: [
      'id',
      'name',
      'header',
      'function_group',
      'function_category',
      'package_id'
    ],
    listColumns: ['name', 'function_group', 'function_category', 'package_id'],
    icon: 'FileText',
    domainGroup: 'Safety',
    allowedRelationships: ['PART_OF']
  },
  ReferenceDocument: {
    label: 'ReferenceDocument',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'document_number', 'revision'],
    listColumns: ['name', 'document_number', 'revision'],
    icon: 'BookOpen',
    domainGroup: 'Safety',
    allowedRelationships: ['PART_OF']
  },
  HazardScenario: {
    label: 'HazardScenario',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name'],
    listColumns: ['name'],
    icon: 'AlertTriangle',
    domainGroup: 'Safety',
    allowedRelationships: ['PART_OF']
  },
  FunctionLogicDiagram: {
    label: 'FunctionLogicDiagram',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'fld_number'],
    listColumns: ['name', 'fld_number'],
    icon: 'Layers',
    domainGroup: 'Safety',
    allowedRelationships: ['CONTAINS']
  },
  SafetyPoint: {
    label: 'SafetyPoint',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'tag_number', 'point_type', 'description'],
    listColumns: ['name', 'point_type', 'safety_related'],
    icon: 'Radio',
    domainGroup: 'Safety',
    allowedRelationships: []
  },
  SoapEndpoint: {
    label: 'SoapEndpoint',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'url', 'auth_kind', 'current_contract_hash'],
    listColumns: ['name', 'url', 'auth_kind', 'enabled'],
    icon: 'Webhook',
    domainGroup: 'Soap',
    allowedRelationships: ['USES_CONTRACT']
  },
  SoapContract: {
    label: 'SoapContract',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'contract_hash', 'target_namespace', 'service_name'],
    listColumns: ['name', 'service_name', 'port_name', 'soap_version'],
    icon: 'Webhook',
    domainGroup: 'Soap',
    allowedRelationships: ['DECLARES_OPERATION']
  },
  SoapOperation: {
    label: 'SoapOperation',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'operation_key', 'soap_action', 'access'],
    listColumns: ['name', 'operation_key', 'access', 'agent_enabled'],
    icon: 'Webhook',
    domainGroup: 'Soap',
    allowedRelationships: []
  },
  Area: {
    label: 'Area',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'area_kind'],
    listColumns: ['name', 'area_kind'],
    icon: 'MapPin',
    domainGroup: 'Spatial',
    allowedRelationships: ['EXHIBITS_SYMPTOM', 'PART_OF']
  },
  FaultSymptom: {
    label: 'FaultSymptom',
    displayLabelField: 'symptom',
    searchableProperties: ['id', 'symptom', 'kind', 'severity', 'description'],
    listColumns: ['symptom', 'kind', 'severity'],
    icon: 'TriangleAlert',
    domainGroup: 'Troubleshooting',
    allowedRelationships: []
  },
  Observer: {
    label: 'Observer',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'kind', 'status'],
    listColumns: ['name', 'kind', 'status'],
    icon: 'Eye',
    domainGroup: 'Troubleshooting',
    allowedRelationships: ['CAN_OBSERVE']
  },
  FaultCause: {
    label: 'FaultCause',
    displayLabelField: 'cause',
    searchableProperties: ['id', 'cause', 'description'],
    listColumns: ['cause', 'description'],
    icon: 'TriangleAlert',
    domainGroup: 'Troubleshooting',
    allowedRelationships: []
  },
  Problem: {
    label: 'Problem',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'description'],
    listColumns: ['name', 'description', 'record_kind'],
    icon: 'OctagonAlert',
    domainGroup: 'Troubleshooting',
    allowedRelationships: ['INDUCES', 'CAUSED_BY', 'APPLIES_TO', 'HAS_SYMPTOM', 'MAY_BE_CAUSED_BY']
  },
  Intent: {
    label: 'Intent',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'description'],
    listColumns: ['name', 'description'],
    icon: 'TriangleAlert',
    domainGroup: 'Troubleshooting',
    allowedRelationships: ['HAS_PHRASE']
  },
  OperatorPhrase: {
    label: 'OperatorPhrase',
    displayLabelField: 'phrase',
    searchableProperties: ['id', 'phrase', 'intent_name', 'description'],
    listColumns: ['phrase', 'intent_name', 'description'],
    icon: 'TriangleAlert',
    domainGroup: 'Troubleshooting',
    allowedRelationships: ['HAS_INTENT']
  },
  Utility: {
    label: 'Utility',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'utility_kind'],
    listColumns: ['name', 'utility_kind'],
    icon: 'Zap',
    domainGroup: 'Utilities',
    allowedRelationships: []
  },
  VisionSystem: {
    label: 'VisionSystem',
    displayLabelField: 'name',
    searchableProperties: [
      'id',
      'name',
      'vendor',
      'product_family',
      'model',
      'ip_address',
      'plc_module_name',
      'serial_number'
    ],
    listColumns: ['name', 'product_family', 'model', 'ip_address'],
    icon: 'Camera',
    domainGroup: 'Vision',
    allowedRelationships: ['HAS_JOB', 'HAS_IO_TAG']
  },
  VisionJob: {
    label: 'VisionJob',
    displayLabelField: 'name',
    searchableProperties: ['id', 'name', 'format', 'file_name', 'camera_model'],
    listColumns: ['name', 'format', 'camera_model', 'cell_count'],
    icon: 'Camera',
    domainGroup: 'Vision',
    allowedRelationships: []
  }
}

export function getNodeTypeSchema(label: NodeLabel): GraphNodeTypeSchema {
  return GRAPH_NODE_TYPE_REGISTRY[label]
}
